<script>
    import LySection from '../components/LySection.svelte';
    import { ValueService } from '../../services/ValueService.js';
    import { setContext } from 'svelte';

    /**
     * @typedef {import('../../services/ValueService.js').ValueCssColor} ValueCssColor
     */

    /**
     * @type {{
     *     tag?: string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     rounded?: boolean | string,
     *     bg?: boolean | string,
     *     shadow?: boolean | string,
     *     wrapper?: boolean | string,
     *     addClass?: string,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let {
        tag = 'section',
        mt = 0,
        mb = 0,
        rounded = true,
        bg = true,
        shadow = true,
        wrapper = false,
        addClass = '',
        children,
    } = $props();

    /** @type {{value:ValueCssColor|null}} */
    let colors = $state({ value: null });
    $effect(() => {
        colors.value = ValueService.splitCssColor(bg, true);
    });
    setContext('ly-table-colors', colors);

    // -
    const thisAddClass = $derived(ValueService.toStringSingleLine((addClass ?? '') + ' overflow-hidden'));
    const thisBgNext = $derived(colors.value?.next || true);
    const thisDivide = $derived(colors.value?.divide || '');
</script>

<LySection {tag} {mt} {mb} bg={thisBgNext} {rounded} {shadow} {wrapper} addClass={thisAddClass} border={true}>
    <table class="w-full divide-y-2 {thisDivide}">
        {@render children?.()}
    </table>
</LySection>
